import { EventEmitter, Inject, Injectable, Output } from '@angular/core';
import { Site, User } from 'solar-bo';
import { AuthenticationServiceAbs, AuthFlowService, AUTH_SERVICE_PROVIDER_TOKEN } from 'baseauth';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouteReuseStrategy } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { Company } from 'solar-bo';
import { CompanyTypeEnum } from 'solar-bo';
import { ISdsAction, SdsService } from './sds.service';
import { SolarDatabase } from '@solar/solar/services/solardatabase';
import { NotifyService } from '../components/notificationsview/notify.service';
import { UploadService } from 'guploadmgr';
import { VersionCheck } from '@solar/shared/version-check';
import { ErrorcontrolService } from 'basecomponents';
import { AppConfig } from '@solar/app.config';
import { Notification } from '@solar/components/notificationsview';
import { AppReuseStrategy } from '@solar/shared/AppReuseStrategy';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  //company: Company;
  company_type: string;
  @Output() menuSelectedEvent: EventEmitter<any> = new EventEmitter();
  @Output() uiMainOptionsEvent: EventEmitter<any> = new EventEmitter();
  routeReuseStrategyEvent = new Subject<any>();


  private _ui_main_options = { palette: "darkblue" };
  public get ui_main_options() {
    return this._ui_main_options;
  }
  public set ui_main_options(value) {
    this._ui_main_options = value;
    this.uiMainOptionsEvent.emit(value);
  }

  private checkVersionHelper: VersionCheck;

  constructor(
    @Inject(AUTH_SERVICE_PROVIDER_TOKEN) public authService: AuthenticationServiceAbs
    , public authFlowService: AuthFlowService
    , public dialog: MatDialog
    , public router: Router
    , private sdsService: SdsService
    , public notifyService: NotifyService
    , public uploadService: UploadService
    , public errorcontrolservice: ErrorcontrolService
    , private appReuseStrategy: RouteReuseStrategy
  ) {
    AppConfig.restoreConfiguration();
    let appReuseStrategyInstance = this.appReuseStrategy as AppReuseStrategy;
    appReuseStrategyInstance.cacheEvent.subscribe(res => this.routeReuseStrategyEventHandler(res));
    const authServiceObj: AuthenticationService = authService as AuthenticationService;
    authServiceObj.currentUserSubject.subscribe(user => this.userAuthHandler(user));

    this.checkAppVersion();


  }

  public get currentUserValue(): User {
    return this.authService.currentUserValue;
  }
  public get company(): Company {
    let user: User = this.authService.currentUserValue;
    return user.company;
  }

  userAuthHandler(user: User) {
    this.configUserUIOptions();
  }

  logout() {
    let appReuseStrategy1 = this.appReuseStrategy as AppReuseStrategy;
    this.authService.logout();
    this.authFlowService.reset();
    this.addAction("LOGOUT", null);
    this.router.navigate(['/login']);

    appReuseStrategy1.storedRoutesClear();

  }

  private routeReuseStrategyEventHandler(event: any) {
    console.log("routeReuseStrategyEventHandler", event);
    this.routeReuseStrategyEvent.next(event);
  }




  /**
 * Check if user has access to resource
 * Usage: Pass the resource id like the button_name, function, etc
 * This must be validate with the relation between resourceid in the table(now is a class in code) that relates the resourceid with profiles.
 * @param resourceId resource identifier
 */
  public checkAuthorizationById(resourceId: string): boolean {
    return this.authFlowService.checkAuthorizationById(resourceId);
  }

  navigateTo(path) {
    this.router.navigate([path]);
  }

  navigateToSite(site: Site) {
    this.router.navigate(["/solar/sites"]).then(
      res => {
        console.log("navigateToSite", res);
        //console.log(this.router);
        this.sdsService.newAction({ action: "SITESELECTED", value: site });
      }

    );
    console.log(this.router);
  }

  get actions(): Observable<ISdsAction> {
    return this.sdsService.actions;
  }
  addAction(action: string, value: any) {
    this.sdsService.newAction({ action: action, value: value });
  }


  /**
   * check if company is an standard company
   */
  companyTypeStandard(): CompanyTypeEnum {
    let company = this.currentUserValue.company;
    if (!company.info) {
      return CompanyTypeEnum.STD;
    } else if (company.info.company_type) {
      let company_type = company.info.company_type;
      if (company_type === "VERIFIER") {
        return CompanyTypeEnum.VERIFIER;
      }
    }

    return CompanyTypeEnum.STD;
  }

  cleanCache() {
    let db = new SolarDatabase();
    db.delete();
  }

  menuSelectedEvent_raise(item) {
    console.log("menuSelectedEvent_handler: ", item);
    this.menuSelectedEvent.emit(item);
  }

  private lastVersionChecked = "";
  private checkAppVersion() {
    let url: string = "/assets/appversion.json";
    let appVersionTimerInterval = AppConfig.versionCheckInterval;// 1000 * 60 * 30; //in milliseconds, defaults to 30 minutes
    let versionCheckHelper: VersionCheck = new VersionCheck(url, appVersionTimerInterval);
    versionCheckHelper.notify$.subscribe(res => {
      if (res) {
        let actual_version: any = AppConfig.app_version.replace(".DEV", "");
        actual_version = AppConfig.app_version.replace("DEV", "");
        //actual_version = +actual_version.replace(".", "");


        let versionCompareResult = this.versionCompare(res.version,actual_version);

        if (versionCompareResult == 1) {
          //smaller
          this.lastVersionChecked = res.version;
          let msgstr = "New version available: <b>" + res.version + "</b> Please reload application.";
          let notification: Notification = new Notification();
          notification.id = 'VERSION_NEW';
          notification.type = "WARNING";
          notification.message = msgstr;
          notification.date = res.date;
          notification.messageObject = res;
          this.notifyService.addNotification(notification);
        }
        else if (versionCompareResult == -1) {
          //greater, but we are not using this option
        }

        else {
          //equal nothing to do
        }
      }
    })
    //versionCheckHelper.callBacks.push(this.validateVersion.bind(this));
    versionCheckHelper.checkAppVersionTask();

  }

  private versionCompare(new_version, actual_version) {
    if (new_version === actual_version) {
      return 0;
    }

    if (actual_version == null) {
      return 1;
    }

    let a_new = new_version.split(".");
    let a_old = actual_version.split(".");
    let len = Math.min(a_new.length, a_old.length);

    for (let i = 0; i < len; i++) {
      a_new[i]= parseInt(a_new[i]);
      a_old[i]= parseInt(a_old[i]);  
    }
    

    

    if (a_new[0] > a_old[0]) {
      return 1;
    }
    else if (a_new[0] < a_old[0]) {
      return -1;
    }
    else {
      if (a_new[1] > a_old[1]) {
        return 1;
      }
      else if (a_new[1] < a_old[1]) {
        return -1;
      }
      else {
        if (a_new[2] > a_old[2]) {
          return 1;
        }
        else if (a_new[2] < a_old[2]) {
          return -1;
        }   
        else{
          return 0;
        }     
      }
    }
  }


  configUserUIOptions() {
    if (this.currentUserValue==null){
      return;
    }
    let options = this.currentUserValue.info["PREFERENCES"];
    if (!options) {
      this._ui_main_options = { palette: "darkblue" };
    }
    else {
      this._ui_main_options = options;
    }
  }



}


